export const hour24To12 = hour =>
  hour === undefined
    ? { isAm: true }
    : {
        hour: hour % 12 || 12,
        isAm: hour < 12,
      };

export const hour12To24 = (hour, isAm) =>
  hour + (isAm && hour === 12 ? -12 : !isAm && hour < 12 ? 12 : 0);

export const minuteDigitToInt = a => Number(a);

export const minuteIntToDigit = a => ('00' + a).substr(-2); // 1 -> 01
